import { makeEntityScaffold } from '@classpass/saga-tools';
import _hasIn from 'lodash/hasIn';
import { transformAvailabilityDataToEntityShape } from 'features/ManageServices/ManageServices.helpers';
import { transformPractitionerData } from 'features/ManageServices/Practitioners/Practitioners.helpers';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

const get = (httpClient, venueId) => {
  return httpClient
    .get(URLS.manageServices.practitioners.list(venueId))
    .then(response => response.data.data)
    .then(transformKeysToCamelCase)
    .then(transformAvailabilityDataToEntityShape);
};

const put = (httpClient, venueId, practitionerData) => {
  const { id, ...restPractitionerData } = practitionerData;

  const endpoint = URLS.manageServices.practitioners.update(venueId, id);
  return httpClient
    .put(endpoint, transformPractitionerData(restPractitionerData))
    .then(response => transformKeysToCamelCase(response.data.data));
};

const handler = ({ httpClient }, venueId, practitionerData) => {
  let promise = Promise.resolve();
  if (_hasIn(practitionerData, 'id')) {
    promise = put(httpClient, venueId, practitionerData);
  }

  return promise.then(() => get(httpClient, venueId));
};
export default makeEntityScaffold('SAGA.API.FETCH_PRACTITIONERS', handler, { defaultKey: 1 });
